import { footerContent } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          <div className="lg:col-span-1">
            <a href="#hero" className="inline-flex items-center gap-2 no-underline mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">
                青柠影院
              </span>
            </a>
            <p className="text-sm text-background-400 leading-relaxed max-w-sm">
              {footerContent.intro}
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">快速导航</h3>
            <div className="grid grid-cols-2 gap-2">
              {footerContent.links.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap no-underline"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 青柠影院 - 最新电影在线观看平台。本站所有内容仅供交流学习之用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#faq" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline">
                常见问题
              </a>
              <a href="#about" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline">
                关于我们
              </a>
              <a href="#contact" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline">
                联系我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}